import type { PricingCatalog } from "./pricingCatalog";
import { isLaunchFreeBillingCatalog } from "./pricingCatalog";

export type TrialCopy = {
  headlineAccent: string;
  subtitle: string;
  ctaLabel: string;
  footerNote: string;
  shortLabel: string;
};

const LAUNCH_FREE_COPY: TrialCopy = {
  headlineAccent: "1.5 Months",
  subtitle: "Early joiner offer — no credit card required.",
  ctaLabel: "Activate 1.5-Month Free Trial",
  footerNote: "No credit card required.",
  shortLabel: "1.5-month free trial for early joiners",
};

const PAID_TRIAL_COPY: TrialCopy = {
  headlineAccent: "7 Days",
  subtitle: "Start with a 7-day free trial — cancel anytime.",
  ctaLabel: "Choose a plan",
  footerNote: "Credit card required. Cancel anytime.",
  shortLabel: "7-day free trial",
};

/** Safepay guest Express checkout — no Safepay Login/Signup. */
const SAFEPAY_TRIAL_COPY: TrialCopy = {
  headlineAccent: "7 Days",
  subtitle: "Pick a plan on Billing, then pay securely with your card — no Safepay account needed.",
  ctaLabel: "Choose a plan",
  footerNote: "Secure card payment. No Safepay login or signup. Cancel anytime.",
  shortLabel: "7-day free trial",
};

export function getTrialCopy(catalog?: PricingCatalog | null): TrialCopy {
  if (catalog && isLaunchFreeBillingCatalog(catalog)) return LAUNCH_FREE_COPY;
  if (String(catalog?.billingMode || "").toLowerCase() === "safepay") {
    return SAFEPAY_TRIAL_COPY;
  }
  return PAID_TRIAL_COPY;
}

export function getTrialCopyFromLaunchFlag(isLaunchFreeBilling: boolean): TrialCopy {
  return isLaunchFreeBilling ? LAUNCH_FREE_COPY : PAID_TRIAL_COPY;
}
